import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import DataTable from "react-data-table-component";
import Loader from "../components/loader";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {useParams, NavLink} from   "react-router-dom";
import ReactCountryFlag from "react-country-flag";

const ViewInventoryDetails =()=>{

    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [currencyData, setCurrencyData] = useState([]);
    const [inventoryDetails, setInventoryDetails] = useState({
        productTitle: '', artistName: ''
        
        // Additional fields as needed
    });

    // Function to fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');                
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (id) {
            
            fetchData(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetInventoryDetailsToViewByID?id=${id}`, setInventoryDetails);
            fetchData(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetInventoryRateInDifferentCurrencyByID?id=${id}`, setCurrencyData);
        }
    }, [id, fetchData]);

    const columns = [
        {
            name: "",
            cell: row => (
                <div>
                    {/* Display the country name and flag */}
                    <ReactCountryFlag countryCode={row.code} svg style={{ width: '2em', height: '2em' }} />
                </div>
            ),
            width: "50px",
        },                
        {
            name: "Currency",
            selector: row => row.currency,
            width: "80px",
        },
        {
            name: "ROE",
            selector: row => row.conversionValue,
            width: "80px",
        },
        {
            name: "MRP",
            selector: (row) => row.mrp,
            width: "100px",
        },
        {
            name: "Discount",
            selector: row => row.discount,
            width: "100px",
        },
        {
            name: "Disc Price",
            selector: (row) => row.discountedRate,
            width: "100px",
        },
        {
            name: "GST Rate",
            selector: row => row.gstRate,
            width: "100px",
        },
        {
            name: "GST Amount",
            selector: (row) => row.gstAmount,
            width: "100px",
        },
        {
            name: "Display Price",
            selector: row => row.includingGST,
            width: "120px",
        } ,
        {
            name: "Ship Cost",
            selector: (row) => row.shippingCost,
            width: "100px",
        },
        {
            name: "GST",
            selector: row => row.shippingGSTRate,
            width: "100px",
        },
        {
            name: "GST Amount",
            selector: row => row.shippingGST,
            width: "100px",
        }  
    ]
    return(
        <>
            {loading ? <Loader /> : ''}
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Inventory Details' icon='bi bi-activity' />
                    {inventoryDetails ? (
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Inventory Details</div>
                                    <div className="card-body">
                                    <NavLink className="btn btn-primary float-end" to={`/addInventory/${id}`}><i class="bi bi-pencil-square"></i> Edit</NavLink>
                                        <NavLink className="btn btn-primary float-end" to={`/inventoryAll`} style={{ marginRight: '10px' }}><i class="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        <form>
                                        <div className="p-4 pt-2">  
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label><img className="m-2" src={`../images/products/full/${inventoryDetails.image}`} alt=" " width="80px" /></label>
                                                </div>
                                                </div>
                                                <div className="row">
                                                    
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork Title : </label>
                                                            <label>{inventoryDetails.productTitle}</label>  
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork Code : </label>
                                                            <label> {inventoryDetails.productCode}</label>  
                                                            </h5>
                                                        </div>
                                                    
                                                </div>
                                                <div className="row">
                                                    
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h6>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artist : </label>
                                                            <label> {inventoryDetails.artistName}</label>  
                                                            </h6>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h6>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>End date : </label>
                                                            <label> {new Date(inventoryDetails.expiryDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</label>                                                              
                                                            </h6>
                                                        </div>
                                                    
                                                </div>
                                                <div className="row">
                                                    
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h6>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Status : </label>
                                                            <label> {inventoryDetails.statusName}</label>  
                                                            </h6>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h6>
                                                            </h6>
                                                        </div>
                                                    
                                                </div>
                                                <div className="row">  
                                                <DataTable columns={columns} data={currencyData} />
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <h6>
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}> Terms & Conditions : </label>
                                                        </h6>
                                                        <div style={{ whiteSpace: "pre-line", width: "1350px" }}><label dangerouslySetInnerHTML={{ __html: inventoryDetails.conditions }}/></div>
                                                        
                                                    </div>  
                                                </div>
                                                
                                                
                                        </div>
                                                
                                        </form>
                                    </div>




                                </div>

                            </div>
                        </div>
                    </div>
                    

                    
                    
                    ): (
                        // Render a loading indicator or some placeholder while waiting for data
                        <div>Loading...</div>
                    )}

                    <Footer />
                </div>
            </div>
        </>
    );

};
export default ViewInventoryDetails;